import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddReferralPage = () => {
    const [formValues, setFormValues] = useState({
        title: "",
        amount: "",
        description: "",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const navigate = useNavigate();

    const handleFormSubmit = async () => {
        setLoading(true);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                // console.log("Access required");
                return;
            }

            const response = await axios.post(
                `${process.env.REACT_APP_INSTITUTION_BASEURL}/create-referral`,
                formValues,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 201) {
                setSnackbarMessage("Referral created successfully!");
                setSnackbarSeverity("success");
                setOpenSnackbar(true);
                setTimeout(() => {
                    navigate("/referrals-list"); // Assuming this route is for viewing all referrals
                }, 2000);
            }
        } catch (err) {
            setLoading(false);
            setSnackbarMessage("Error creating referral. Please try again.");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
    };

    return (
        <div className="row gy-4">
            <div className="col-lg-8" style={styles.cardContent(loading)}>
                <div className="card h-100">
                    <div className="card-body p-24">
                        <h6 className="text-md text-primary-light mb-16">
                            Create Referral
                        </h6>

                        {/* Title */}
                        <div className="mb-24">
                            <label
                                htmlFor="title"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                                Title <span className="text-danger-600">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control radius-8"
                                id="title"
                                placeholder="Enter Referral Title"
                                value={formValues.title}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, title: e.target.value })
                                }
                                required
                            />
                        </div>
                        {/* Description */}
                        <div className="mb-24">
                            <label
                                htmlFor="description"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                                Description <span className="text-danger-600">*</span>
                            </label>
                            <textarea       
                                type="text"
                                className="form-control radius-8"
                                id="description"
                                placeholder="Enter Referral Description"
                                value={formValues.description}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, description: e.target.value })
                                }
                                required
                            />
                        </div>
                        {/* Amount */}
                        <div className="mb-24">
                            <label
                                htmlFor="amount"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                                Amount in $<span className="text-danger-600">*</span>
                            </label>
                            <input
                                type="number"
                                className="form-control radius-8"
                                id="amount"
                                placeholder="Enter Referral Amount"
                                value={formValues.amount}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, amount: e.target.value })
                                }
                                required
                            />
                        </div>

                        {/* Action Buttons */}
                        <div className="d-flex align-items-center justify-content-between gap-3">
                            <button
                                type="button"
                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                                onClick={() => navigate("/referrals-list")}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                onClick={handleFormSubmit}
                                disabled={loading}
                            >
                                {loading && (
                                    <div
                                        className="loader-container"
                                        style={styles.loaderContainer}
                                    >
                                        <CircularProgress />
                                    </div>
                                )}
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Snackbar */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity={snackbarSeverity}
                //   sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

// Add CSS for loader
const styles = {
    loaderContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
    },
    cardContent: (loading) => ({
        opacity: loading ? 0.5 : 1,
    }),
};

export default AddReferralPage;
